import { legacy_createStore as createStore } from 'redux';
import appReducer from './appReducer';

const store = createStore(
    appReducer
);

export default store;
